export default __webpack_public_path__ + "static/media/img1.5d20631a.svg";